<section class="root-home-skeleton" data-testid="root-home-skeleton">
  <section class="root-home-skeleton__hero">
    <div class="root-home-skeleton__hero-bg"></div>
    <div class="root-home-skeleton__hero-inner container">
      <div class="root-home-skeleton__hero-copy">
        <p-skeleton width="8rem" height="1rem" borderRadius="9999px" />
        <p-skeleton width="min(100%, 38rem)" height="3.5rem" />
        <p-skeleton width="min(100%, 30rem)" height="1.25rem" />
        <p-skeleton width="min(100%, 24rem)" height="1.25rem" />
        <a
          routerLink="/d2d"
          pButton
          size="large"
          class="root-home-skeleton__cta"
          aria-label="Ir a envíos D2D"
        >
          Ir a envíos (D2D)
        </a>
      </div>

      <div class="root-home-skeleton__search-card">
        <div class="root-home-skeleton__search-row">
          <p-skeleton width="100%" height="3.5rem" />
          <p-skeleton width="100%" height="3.5rem" />
        </div>
        <div class="root-home-skeleton__search-row root-home-skeleton__search-row--wide">
          <p-skeleton width="100%" height="3.5rem" />
          <p-skeleton width="12rem" height="3.5rem" borderRadius="9999px" />
        </div>
      </div>

      <div class="root-home-skeleton__hero-stats">
        @for (item of heroStats; track item) {
          <div class="root-home-skeleton__stat-card">
            <p-skeleton shape="circle" size="2.75rem" />
            <div class="root-home-skeleton__stat-copy">
              <p-skeleton width="6rem" height="1rem" />
              <p-skeleton width="9rem" height="0.875rem" />
            </div>
          </div>
        }
      </div>
    </div>
  </section>

  <section class="root-home-skeleton__section root-home-skeleton__section--light">
    <div class="root-home-skeleton__section-inner container">
      <div class="root-home-skeleton__section-heading">
        <p-skeleton width="14rem" height="2rem" />
        <p-skeleton width="min(100%, 40rem)" height="1.125rem" />
      </div>

      <div class="root-home-skeleton__service-grid">
        @for (card of serviceCards; track card) {
          <div class="root-home-skeleton__service-card">
            <p-skeleton width="100%" height="13rem" />
            <p-skeleton width="65%" height="1.25rem" />
            <p-skeleton width="100%" height="0.875rem" />
            <p-skeleton width="90%" height="0.875rem" />
          </div>
        }
      </div>

      <p-skeleton width="14rem" height="3rem" borderRadius="9999px" />
    </div>
  </section>

  <section class="root-home-skeleton__section root-home-skeleton__section--accent">
    <div class="root-home-skeleton__section-inner container">
      <div class="root-home-skeleton__section-heading">
        <p-skeleton width="16rem" height="2rem" />
        <p-skeleton width="min(100%, 42rem)" height="1.125rem" />
      </div>

      <div class="root-home-skeleton__faq-list">
        @for (item of faqItems; track item) {
          <div class="root-home-skeleton__faq-item">
            <p-skeleton width="70%" height="1.25rem" />
            <p-skeleton shape="circle" size="1.75rem" />
          </div>
        }
      </div>
    </div>
  </section>

  <section class="root-home-skeleton__section root-home-skeleton__section--light">
    <div class="root-home-skeleton__section-inner container">
      <div class="root-home-skeleton__section-heading">
        <p-skeleton width="13rem" height="2rem" />
        <p-skeleton width="min(100%, 32rem)" height="1.125rem" />
      </div>

      <div class="root-home-skeleton__partners">
        @for (partner of partnerCards; track partner) {
          <p-skeleton width="100%" height="6rem" />
        }
      </div>
    </div>
  </section>
</section>
